import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import GameConfig from "../model/GameConfig";
import TutorialOverlayMediatorEvent from "../model/TutorialOverlayMediatorEvent";
import TutorialPlayerEvent from "../model/TutorialPlayerEvent";
import ProgressDotsView from "./ProgressDotsView";

export default class TutorialOverlayMediator extends AbstractPopupMediator {

    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {somajs.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {GameConfig} gameConfig 
     */
    constructor(target, dispatcher, languagePack, layoutManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager);
        this._gameConfig = gameConfig;
    }


    initialize() {
        super.initialize();
        this._setPage(0);

        this.registerEventListener(TutorialPlayerEvent.NEXT_STEP, this._handleNextTutorialStep.bind(this));

        if (ranj.DEBUG) {
            this._handleKeyUp = this._handleKeyUp.bind(this);
            window.document.addEventListener('keyup', this._handleKeyUp);
        }
    }

    destroy() {
        super.destroy();
        if (ranj.DEBUG) {
            window.document.removeEventListener('keyup', this._handleKeyUp);
        }
    }

    _handleKeyUp(e) {
        const c = String.fromCharCode(e.which);
        if (c == "X") this._changePage(99);
    }

    _handleNextTutorialStep(evt) {
        const stepIndex = evt.params.data.stepIndex;
        this._setPage(stepIndex);
    }


    _changePage(delta) {
        const f = Math.max(0, this._target.currentFrame + delta);
        const n = this._target.totalFrames;
        if (f >= n) {
            this.close();
        } else {
            const duration = this._gameConfig.getValue("tutorial.crossFadeDuration");
            const wait = this._gameConfig.getValue("tutorial.crossFadeDelay");
            createjs.Tween.get(this._target)
                .to({ alpha: 0 }, duration, createjs.Ease.quadOut)
                .call(() => {
                    this._setPage(f);
                })
                .wait(wait)
                .to({ alpha: 1 }, duration, createjs.Ease.quadIn);
        }
    }

    _setPage(idx) {
        this._target.gotoAndStop(idx);

        const prefix = "tutorial.overlay" + (idx + 1) + ".";

        if (this._target.titleTextfield) {
            this._target.titleTextfield.text = this.getText(prefix + "body");
        }

        if (this._target.bodyTextfield) {
            this._target.bodyTextfield.text = this.getText(prefix + "body");
        }

        if (this._target.actionTextfield) {
            this._target.actionTextfield.text = this.getText(prefix + "action");
        }

        if (this._target.startButton) {
            if (this._startButton) {
                this._startButton.destroy();
                this._startButton = null;
            }

            this._startButton = this.createButton(this._target.startButton, () => {
                this._startButton.setEnabled(false);
                this.dispatch(TutorialOverlayMediatorEvent.FINISH_BUTTON_CLICKED);
            }, this.getText(prefix + "startButton"));
        }

        if (this._target.replayButton) {
            if (this._replayButton) {
                this._replayButton.destroy();
            }

            this._replayButton = this.createButton(this._target.replayButton, () => {
                this._replayButton.setEnabled(false);
                this.dispatch(TutorialOverlayMediatorEvent.REPLAY_BUTTON_CLICKED);
            }, this.getText(prefix + "replayButton"));
        }

        if (this._target.gatekeeperOverlay) {
            if (this._gatekeeperOverlayButton) {
                this._gatekeeperOverlayButton.destroy();
                this._gatekeeperOverlayButton = null;
            }

            this._gatekeeperOverlayButton = this.createButton(this._target.gatekeeperOverlay, () => {
                // eat click
            });
        }

        // const anchorStr = this._gameConfig.getValue("tutorial.anchoring")[idx];
        // let anchor;
        // if (anchorStr) {
        //     anchor = Anchor[anchorStr];
        // } else {
        //     anchor = Anchor.C;
        // }
        // this.unanchorObject(this._target, true);
        // this.anchorObject(this._target, anchor);
    }
}